module.exports = __webpack_public_path__ + "static/WEDDING E&M-25-2f2acc5b60445a252ab71f8ccae79473.jpg";